import React from "react";
import moment from 'moment'
import clsx from "clsx";

import {KeyboardDatePicker} from "@material-ui/pickers";

import {DATE_MUST_BE_IN_PAST, WEEKENDS_IS_NOT_AVAILABLE_MSG} from "../../../../../constants";
import {DATE_IN_PAST_ERROR} from "../../../../../../Trades/constants";

import {useStyles} from "../styles";

const DEFAULT_MIN_DATE = moment('0001-01-01');  // mui default is 1900-01-01

const CalendarFormElement = props => {
  const {
    label,
    required,
    value,
    disabled,
    onChange,
    custom_classes,
    disablePast,
    disableFuture,
    minDate,
    minError,
    maxDate,
    maxError,
    error,
    fixedWidth,
    disableDatesCallback,
    disableWeekends,
    minimisedStyles,
    dataId,
    yearOnly=false,
  } = props;

  const classes = useStyles();

  // In case we do not format moment before send to server moment.toJSON will convert it to UTC (like in Trading) #65622
  // to prevent that keep current timezone by override toJSON method
  const overrideDateToJson = (date) => {
    if(moment.isMoment(date)){
      date.toJSON = function() { return this.format(); };
    }
  };

  overrideDateToJson(value);

  const handleChange = (newValue) => {
    overrideDateToJson(newValue);
    onChange(newValue)
  };

  const filterWeekends = (date) => {
    // Return false if Saturday or Sunday
    date = new Date(date);
    return date.getDay() === 0 || date.getDay() === 6;
  };

  const handleDateValidity = date => {
    if (disableDatesCallback) {
      return disableDatesCallback(date)
    }

    return disableWeekends ? filterWeekends(date) : false;
  };

  const [datePickerError, setDatePickerError] = React.useState(undefined);
  const dateValidityError = React.useMemo(() => {
    return value && handleDateValidity(value) ? (
      disableDatesCallback ? "Das Datum nicht verfügbar" : WEEKENDS_IS_NOT_AVAILABLE_MSG
    ) : undefined;
  }, [value]);

  const handleError = (error) => {
    setDatePickerError(error);
  };

  const helperText = error || datePickerError || dateValidityError;
  const _disableFuture = Boolean(disableFuture) || false;
  const _disabledPast = Boolean(disablePast) || false;

  return (
    <KeyboardDatePicker
      data-id={dataId}
      views={yearOnly ? ["year"] : ["year", "month", "date"]}
      format={yearOnly ? "YYYY" : "DD.MM.YYYY"}
      placeholder={yearOnly ? "JJJJ" : "TT.MM.JJJJ"}
      label={label}
      value={value === undefined ? null : value}  // pass null in case undefined to keep input "controlled"
      disabled={disabled}
      required={required}
      onChange={handleChange}
      disablePast={_disabledPast}
      disableFuture={_disableFuture}
      shouldDisableDate={handleDateValidity}
      minDate={minDate}
      maxDate={maxDate}
      invalidDateMessage={'Falsches Datumsformat.'}
      autoOk={true}
      okLabel={<span style={{textTransform: 'none'}}>Anwenden</span>}
      cancelLabel={<span style={{color: '#B1B1B1', textTransform: 'none'}}>Abbrechen</span>}
      onError={handleError}
      minDateMessage={minError || (_disabledPast && DATE_IN_PAST_ERROR)}
      maxDateMessage={maxError || (_disableFuture && DATE_MUST_BE_IN_PAST)}
      error={!!helperText}
      helperText={helperText}
      style={props.style || {}}
      classes={{
        root: clsx(
          classes.textFieldRoot,
          custom_classes && custom_classes.textFieldRoot,
          fixedWidth && classes.fixedMaxWidthDateField,
          minimisedStyles && classes.minimised
        ),
      }}
      keyboardIcon={<i className={'far fa-calendar'} style={{fontSize: 16}} />}
      InputProps={{
        classes: {
          root: clsx(classes.inputRoot, custom_classes && custom_classes.inputRoot),
          focused: classes.inputFocused,
        }
      }}
      InputLabelProps={{
        shrink: true,
        classes: {
          root: clsx(classes.labelRoot, custom_classes && custom_classes.labelRoot),
          focused: classes.labelFocused,
          asterisk: classes.labelAsterisk
        }
      }}
    />
  )
};

CalendarFormElement.defaultProps = {
  disableWeekends: false,
  minDate: DEFAULT_MIN_DATE,
};

export default CalendarFormElement;
